import * as appActions from "../actions/app";
import {connect} from "redux-vue";
import ModalTemplate from "./ModalTemplate";
import {ADOPTION_TARGET, WEEKS_TARGET} from "../helpers/consts";

const CompletedModal = {
  props: ['app', 'actions', 'reset', 'goTo'],

  /**
   *
   */
  methods: {
    handleContinue() {
      this.goTo('summary');
    }
  },

  /**
   *
   * @param h
   * @returns {null|*}
   */
  render(h) {
    if (!this.app.completed) {
      return null;
    }

    if (this.app.completedError) {
      return (
        <ModalTemplate>
          <div class="w-11/12 lg:w-9/12 mx-auto text-center px-3 py-10 flex flex-col items-center">

            <p class="text-2xl lg:text-3xl font-bold leading-snug">
              Low Adoption Rate
            </p>

            <div class="w-48 h-48 rounded-full bg-brand-blue-100 mt-4 flex items-center justify-center">
              <i class="mt-4 mdi mdi-close-circle-outline text-6xl opacity-25" style="transform: scale(2.5)"></i>
            </div>

            <p class="lg:text-xl">
              {WEEKS_TARGET} weeks have passed, and not all locations have reached at least 80% adoption. Scroll through the
              timeline to review your choices, as well as some additional feedback.
            </p>

            <div class="mt-8 flex flex-col lg:flex-row lg:justify-center lg:text-2xl">
              <button type="button" onClick={this.handleContinue}
                      class="mx-auto rounded-full bg-brand-orange-700 text-white uppercase py-1 px-10 hover:bg-orange-700 focus:outline-none transition-colors duration-100">
                Review Choices
              </button>
              <div class="w-8 h-4"></div>
              <button type="button" onClick={this.reset}
                      class="mx-auto rounded-full bg-brand-orange-700 text-white uppercase py-1 px-10 hover:bg-orange-700 focus:outline-none transition-colors duration-100">
                Retry Simulation
              </button>
            </div>
          </div>
        </ModalTemplate>
      );
    } else if (this.app.completedSuccess) {
      return (
        <ModalTemplate>
          <div class="w-11/12 lg:w-9/12 mx-auto text-center px-3 py-10 flex flex-col items-center">

            <p class="text-2xl lg:text-3xl font-bold leading-snug">
              Congratulations!
            </p>

            <img src="/img/changemanagement/img-trophy.svg" alt="" class="w-48 mt-4"/>

            <p class="lg:text-xl">
              You have reached your goal of all four locations reaching at least {ADOPTION_TARGET}% adoption. The lessons learned
              during this implementation will be applied to national level recommendations for rollout to the entire
              country.
            </p>

            <button type="button" onClick={this.handleContinue}
                    class="mt-8 mx-auto rounded-full bg-brand-orange-700 text-white uppercase py-1 px-10 lg:text-xl hover:bg-orange-700 focus:outline-none transition-colors duration-100">
              Continue
            </button>
          </div>
        </ModalTemplate>
      );
    } else {
      return null;
    }
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
  };
}

function mapActionToProps(dispatch) {
  return {
    goTo: (slide) => dispatch(appActions.goTo(slide)),
    reset: () => dispatch(appActions.reset()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(CompletedModal);
